import { BMButtonGroup, BMCard } from "@traveloka/district-bloom";
import { startOfDay } from "date-fns";
import { useEffect, useState } from "react";
import { StyleSheet } from "react-native";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { appendTestId } from "../../../../utils";
import {
  MobileHomeNextTripProps,
  NextTripTabsType,
} from "./MobileHomeNextTrip";
import NextTripContent from "./NextTripContent";

const testID = "next_trip";

export default function NextTripTabs(props: MobileHomeNextTripProps) {
  const [selectedTab, setSelectedTab] = useState<NextTripTabsType>();

  const { CorporatePostLogin: cr } = useMobileContentResource();

  const items = [
    {
      label: cr.flightTab,
      value: "FLIGHT",
    },
    {
      label: cr.hotelTab,
      value: "HOTEL",
    },
  ];

  function handleTabChange(value: (string | number)[]) {
    if (!value[0]) return;
    setSelectedTab(value[0] as NextTripTabsType);
  }

  useEffect(() => {
    if (props.data.FLIGHT.isLoading || props.data.HOTEL.isLoading) {
      return;
    }

    if (props.data.FLIGHT.productData && !props.data.HOTEL.productData) {
      setSelectedTab("FLIGHT");
      return;
    }
    if (props.data.HOTEL.productData && !props.data.FLIGHT.productData) {
      setSelectedTab("HOTEL");
      return;
    }

    if (props.data.FLIGHT.productData && props.data.HOTEL.productData) {
      const flightDate = startOfDay(
        props.data.FLIGHT.productData.departureDate
      );
      const hotelCheckInDate = startOfDay(
        props.data.HOTEL.productData.checkInDate
      );

      if (flightDate <= hotelCheckInDate) {
        setSelectedTab("FLIGHT");
      } else {
        setSelectedTab("HOTEL");
      }
    }
  }, [props.data]);

  const usedTab = selectedTab ?? "FLIGHT";

  return (
    <BMView spacing="md">
      <BMView>
        <BMButtonGroup
          // Force re-mount when the tab is not fully loaded, to re-trigger the initialValues
          key={selectedTab === undefined ? "not-loaded" : "loaded"}
          items={items}
          onChange={handleTabChange}
          initialValues={[usedTab]}
          multipleValue={false}
          singleRow
          isValueRequired
          testID={appendTestId(testID, "tab")}
        />
      </BMView>
      <BMCard
        style={styles.card}
        layout="COMPACT"
        elevation="FLOAT"
        testID={appendTestId(testID, "container")}
      >
        <NextTripContent {...props} selectedTab={usedTab} />
      </BMCard>
    </BMView>
  );
}

const styles = StyleSheet.create({
  card: {
    height: 90,
  },
});
